$(document).ready(function () {
    $("#save-user-form").validate({
        rules: {
            'email_address': {
                email: true,
                remote: {
                    url: $('body').attr('data-base-url') + 'utility/' + 'checkEmail',
                    type: "post",
                    data: {
                        email: $('input[name="email_address"]').val(),
                        user_id: $( "input[name='id']" ).val()
                    }
                }
            }
        },
        messages: {
            'email_address': {
                remote: "This e-mail is already taken"
            }
        },
        errorElement: 'div',
        errorPlacement: function (error, element) {
            var placement = $(element).data('error');

            if (placement) {
                $(placement).append(error);
            } else {
                error.insertAfter(element);
            }
        }
    });

    $("#comps-form").validate({
        rules: {
            'business_name': {
                required: true
            }
        },
        errorElement: 'div',
        errorPlacement: function (error, element) {
            var placement = $(element).data('error');

            if (placement) {
                $(placement).append(error);
            } else {
                error.insertAfter(element);
            }
        }
    });

    $("#add_company-form").validate({
        rules: {
            'company_name': {
                required: true
            }
        },
        errorElement: 'div',
        errorPlacement: function (error, element) {
            var placement = $(element).data('error');

            if (placement) {
                $(placement).append(error);
            } else {
                error.insertAfter(element);
            }
        }
    });

    $("#add_client-form").validate({
        errorElement: 'div',
        errorPlacement: function (error, element) {
            var placement = $(element).data('error');

            if (placement) {
                $(placement).append(error);
            } else {
                error.insertAfter(element);
            }
        }
    });

    $("#add_coupon-form").validate({
        errorElement: 'div',
        errorPlacement: function (error, element) {
            var placement = $(element).data('error');

            if (placement) {
                $(placement).append(error);
            } else {
                error.insertAfter(element);
            }
        }
    });

    $("#inquire-broker-form").validate({
        rules: {
            'email_address': {
                email: true
            },
            'phone_number': {
                phoneUS: true
            }
        },
        errorElement: 'div',
        errorPlacement: function (error, element) {
            var placement = $(element).data('error');

            if (placement) {
                $(placement).append(error);
            } else {
                error.insertAfter(element);
            }
        }
    });

    $("#contact-broker-form").validate({
        rules: {
            'email_address': {
                email: true
            },
            'phone_number': {
                phoneUS: true
            }
        },
        errorElement: 'div',
        errorPlacement: function (error, element) {
            var placement = $(element).data('error');

            if (placement) {
                $(placement).append(error);
            } else {
                error.insertAfter(element);
            }
        }
    });

    $("#property-form").validate({
        errorElement: 'div',
        errorPlacement: function (error, element) {
            var placement = $(element).data('error');

            if (placement) {
                $(placement).append(error);
            } else {
                error.insertAfter(element);
            }
        }
    });

    $("#evaluation-form").validate({
        errorElement: 'div',
        errorPlacement: function (error, element) {
            var placement = $(element).data('error');

            if (placement) {
                $(placement).append(error);
            } else {
                error.insertAfter(element);
            }
        }
    });
});